import  { useState, useEffect } from "react";
import { InputAdornment } from "@mui/material";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import "jspdf-autotable";
import { useAuth } from "../../../../AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GlobalStyles } from "@mui/system";
import { useParams } from "react-router-dom";

const StudentIndividualMarksList = ({ initialRows }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const navigate = useNavigate();
  const { userId,pId,oId,board,role} = useAuth();
  const studentMarks = JSON.parse(sessionStorage.getItem("studentMarks"));
  const [filteredData, setFilteredData] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState("");
  const [loading, setLoading] = useState(false); // To handle button state
  //Dialog states
  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;

// ---- Fetch Table Data for SSc ----

const fetchClassSectionTableData = async () => {
  if (!studentMarks.studentId || !studentMarks.type) {
    setFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/subjectMarks/getStudentReportCard/${studentMarks.studentId}/${oId}/${pId}?examType=${studentMarks.type}`
    );     
    const data = await response.json();
     if (data?.subjects && Array.isArray(data.subjects)) {
      const filteredSubjects = data.subjects.filter(
  (subject) => Number(subject.marks) > 0
);
      setFilteredData(filteredSubjects);
    } else {
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
    setFilteredData([]);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  
    fetchClassSectionTableData();

}, [studentMarks.studentId,studentMarks.type]); // ✅ Only runs on mount 

const handleEditClick = (row) => {
  setSelectedRow(JSON.parse(JSON.stringify(row))); // deep clone
  setDialogOpen(true);
};
  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };
const handleSaveChanges = async () => {
  if (!selectedRow) {
    toast.error("Invalid selection.");
    return;
  }

  setDialogbtnloading(true);

  try {
    const url = `${baseUrl}/api/subjectMarks/updateStudentMarks/${studentMarks.studentId}/${oId}/${pId}?examType=${studentMarks.type}`;

    const payload = {
      subjects: [
        {
          subjectId: selectedRow.subjectId,   // ✅ send subjectId, not subject name
          marks: Number(selectedRow.marks),   // ✅ total obtained marks
          categories: selectedRow.categories.map((cat) => ({
            scId: cat.scId,                   // ✅ send scId
            obtainedMarks: Number(cat.obtainedMarks || 0), // ✅ only obtained marks
          })),
        },
      ],
    };

    const response = await fetch(url, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const responseText = await response.text();

    if (!response.ok) {
      throw new Error(responseText || "Failed to update Marks.");
    }

    toast.success(responseText || "Marks updated successfully!", {
  autoClose: 1000, // ✅ closes after 1 second
});

    fetchClassSectionTableData();
    handleDialogClose();
  } catch (error) {
    console.error("Error updating Marks:", error);
    toast.error(`Error: ${error.message}`);
  } finally {
    setDialogbtnloading(false);
  }
};

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between", // left and right sides
    width: "100%",                  // full width ensures space-between works
    mb: 2,
  }}
>
  {/* Left: Back icon + title */}
  <Box display="flex" alignItems="center" gap={1}>
    <IconButton
      onClick={() => navigate(-1)}
      sx={{ color: "#2e2a54" }}
    >
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>
    <Typography variant="h5" component="h3" sx={{ fontWeight: "bold" }}>
              <span style={{ color: "#757575", fontSize: "18px" }}>
                {studentMarks?.firstName || studentMarks?.lastName
                  ? `${studentMarks?.firstName || ""} ${studentMarks?.lastName || ""}`.trim() + ""
                  : "N/A "}
                </span> -{studentMarks.type} {"Marks "}
              </Typography>
  </Box>
</Box>
          </div>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1.5 , paddingLeft:"10px"}}>
 
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
    <Typography variant="body1" sx={{ minWidth: 150 }}>
      <strong>Roll No:</strong> {studentMarks?.studentRollNumber || "-"}
    </Typography>
    <Typography variant="body1" sx={{ minWidth: 150 }}>
      <strong>Student Name:</strong> {studentMarks?.firstName || ""} {studentMarks?.lastName || ""}
    </Typography>
    {board === "INTERMEDIATE" && (
      <Typography variant="body1" sx={{ minWidth: 180 }}>
        <strong>Course:</strong> {studentMarks?.course || "-"}
      </Typography>
    )}
  </Box>


  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
    <Typography variant="body1" sx={{ minWidth: 150 }}>
      <strong>{board === "INTERMEDIATE" ? "Year:" : "Class:"}</strong> {studentMarks?.romanNumberClass || "-"}
    </Typography>
    <Typography variant="body1" sx={{ minWidth: 150 }}>
      <strong>Section:</strong> {studentMarks?.sections || "-"}
    </Typography>
  </Box>
</Box>
          <GlobalStyles
                            styles={{
                              '.custom-sidebar-scrollbar': {
                                scrollbarWidth: 'thin', // For Firefox
                                scrollbarColor: 'grey #e0e0e0',
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                                width: '6px', // For WebKit-based browsers
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                                background: '#f1f1f1', // Track color
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                                backgroundColor: 'grey', // Thumb color
                                borderRadius: '10px',
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: '#555',
                              },
                            }}
                          />

                          <TableContainer
  component={Paper}
  sx={{
    borderRadius: 2,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    maxHeight: "69vh",
    overflow: "auto",
    marginTop:'10px'
  }}
  className="custom-sidebar-scrollbar"
>
  <Table stickyHeader>
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            borderRight: "1px solid #ddd",
            padding: "4px",
            textAlign: "center",
            backgroundColor: "#fff9c4",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          S.No
        </TableCell>
        <TableCell
          sx={{
            borderRight: "1px solid #ddd",
            padding: "4px",
            textAlign: "center",
            backgroundColor: "#fff9c4",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Subject
        </TableCell>

       {/* ✅ Dynamic Category Headers */}
{filteredData.length > 0 &&
  filteredData[0].categories.map((cat) => {
    const formatted =
      cat.subjectsCategory
        .toLowerCase()                // make all lowercase
        .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letter of each word

    return (
      <TableCell
        key={cat.subjectsCategory}
        sx={{
          borderRight: "1px solid #ddd",
          padding: "4px",
          textAlign: "center",
          backgroundColor: "#fff9c4",
          fontSize: "14px",
          fontWeight: "bold",
          whiteSpace: "nowrap",
        }}
      >
        {formatted}
      </TableCell>
    );
  })}


        <TableCell
          sx={{
            borderRight: "1px solid #ddd",
            padding: "4px",
            textAlign: "center",
            backgroundColor: "#fff9c4",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Total Marks
        </TableCell>

        <TableCell
          sx={{
            borderRight: "1px solid #ddd",
            padding: "4px",
            textAlign: "center",
            backgroundColor: "#fff9c4",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Grade
        </TableCell>

        <TableCell
          sx={{
            borderRight: "1px solid #ddd",
            padding: "4px",
            textAlign: "center",
            backgroundColor: "#fff9c4",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Action
        </TableCell>
      </TableRow>
    </TableHead>

    {loading ? (
      <TableBody>
        <TableRow>
          <TableCell colSpan={20} style={{ textAlign: "center", padding: "20px" }}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <CircularProgress />
              <Typography variant="body2" sx={{ mt: 1 }}>
                Loading Data...
              </Typography>
            </Box>
          </TableCell>
        </TableRow>
      </TableBody>
    ) : !filteredData || filteredData.length === 0 ? (
      <TableBody>
        <TableRow>
          <TableCell colSpan={20} sx={{ textAlign: "center" }}>
            No data found
          </TableCell>
        </TableRow>
      </TableBody>
    ) : (
      <TableBody>
        {filteredData.map((row, index) => (
          <TableRow
            key={row.subjectId}
            style={{
              backgroundColor: "white",
              transition: "background-color 0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f5f5f5";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "white";
            }}
          >
            {/* S.No */}
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
              }}
            >
              {index + 1}
            </TableCell>

            {/* Subject */}
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
              }}
            >
              {row.subject}
            </TableCell>

            {/* ✅ Category values */}
            {row.categories.map((cat) => (
              <TableCell
                key={cat.subjectsCategory}
                sx={{
                  borderRight: "1px solid #ddd",
                  padding: "4px",
                  textAlign: "center",
                }}
              >
                {cat.obtainedMarks}/{cat.totalMarks}
              </TableCell>
            ))}

            {/* Total Marks */}
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
              }}
            >
              {row.marks}/{row.subjectMarks}
            </TableCell>

            {/* Grade */}
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
              }}
            >
              {row.grade}
            </TableCell>

            {/* Action */}
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "2px",
                textAlign: "center",
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "center", gap: "4px" }}>
                <Button
                  sx={{
                    backgroundColor: "#1565c0",
                    color: "white",
                    "&:hover": { backgroundColor: "#0d47a1" },
                    padding: "2px 4px",
                  }}
                  onClick={() => handleEditClick(row)}
                >
                  Edit
                </Button>
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    )}
  </Table>
</TableContainer>


      {/* Dialog for editing */}
              <Dialog open={isDialogOpen} onClose={handleDialogClose} maxWidth="sm" fullWidth>
  <DialogTitle style={{ fontWeight: "bold" }}>Edit Marks</DialogTitle>
  <DialogContent>
    <Grid container spacing={1}>
     
      {/* Subject */}
      <Grid item xs={6}>
        <TextField
          label="Subject"
          value={selectedRow?.subject || ""}
          fullWidth
          margin="normal"
          disabled
          InputProps={{
            style: { backgroundColor: "#f0f0f0", color: "#6c757d", fontWeight: "bold" },
          }}
        />
      </Grid>

{/* ✅ Dynamic Category Fields */}
{selectedRow?.categories?.map((cat, idx) => (
  <Grid item xs={6} key={idx}>
    <TextField
      fullWidth
      margin="normal"
      label={cat.subjectsCategory}
      value={cat.obtainedMarks}
      onChange={(e) => {
        let value = e.target.value;

        if (/^\d*$/.test(value)) {
          const numericValue = Number(value);

          // clamp: max = totalMarks
          const finalValue =
            numericValue > cat.totalMarks ? cat.totalMarks : numericValue;

          const updatedCategories = [...selectedRow.categories];
          updatedCategories[idx].obtainedMarks = finalValue;

          // ✅ compute new total from updated categories
          const newTotal = updatedCategories.reduce(
            (sum, c) => sum + Number(c.obtainedMarks || 0),
            0
          );

          setSelectedRow((prev) => ({
            ...prev,
            categories: updatedCategories,
            marks: newTotal, // ✅ keep total in sync
          }));
        }
      }}
      type="text"
      inputProps={{
        inputMode: "numeric",
        pattern: "[0-9]*",
        min: 0,
        max: cat.totalMarks,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Box sx={{ fontWeight: "bold", fontSize: "1rem" }}>
              /{cat.totalMarks}
            </Box>
          </InputAdornment>
        ),
      }}
    />
  </Grid>
))}
{/* Total Marks */}
<Grid item xs={6}>
  <TextField
    fullWidth
    margin="normal"
    label="Total Marks"
    value={selectedRow?.marks || ""}
    onChange={(e) => {
      let value = e.target.value;

      if (/^\d*$/.test(value)) {
        const numericValue = Number(value);

        // clamp to subjectMarks
        const finalValue =
          numericValue > selectedRow?.subjectMarks
            ? selectedRow.subjectMarks
            : numericValue;

        // ✅ manual override allowed
        setSelectedRow((prev) => ({
          ...prev,
          marks: finalValue,
        }));
      }
    }}
    type="text"
    inputProps={{
      inputMode: "numeric",
      pattern: "[0-9]*",
      min: 0,
      max: selectedRow?.subjectMarks,
    }}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <Box sx={{ fontWeight: "bold", fontSize: "1rem" }}>
            /{selectedRow?.subjectMarks || ""}
          </Box>
        </InputAdornment>
      ),
    }}
    sx={{
      "& .MuiOutlinedInput-root": {
        backgroundColor: "#f3f6ff",
        borderRadius: "10px",
        "& fieldset": { borderColor: "#3C3972", borderWidth: "2px" },
        "&:hover fieldset": { borderColor: "#6a5acd" },
        "&.Mui-focused fieldset": {
          borderColor: "#ff9800",
          boxShadow: "0 0 6px rgba(255,152,0,0.6)",
        },
      },
      "& .MuiInputLabel-root": { color: "#3C3972", fontWeight: "bold" },
      "& .MuiInputLabel-root.Mui-focused": { color: "#ff9800" },
    }}
  />
</Grid>
    </Grid>
  </DialogContent>

  <DialogActions>
    <Button onClick={handleDialogClose} color="primary" variant="outlined">
      Cancel
    </Button>
    <Button
      onClick={handleSaveChanges}
      color="primary"
      variant="contained"
      disabled={dialogbtnloading}
      sx={{
        fontWeight: 600,
        backgroundColor: "#3C3972",
        "&:hover": { backgroundColor: "#3C3972" },
      }}
    >
      {dialogbtnloading ? (
        <CircularProgress size={24} sx={{ color: "white" }} />
      ) : (
        "Save"
      )}
    </Button>
  </DialogActions>
</Dialog>
        </CardContent>
        <ToastContainer position="top-right" autoClose={2000} />
      </Card>
    </Box>
  );
};

export default StudentIndividualMarksList;